import {storage, StorageKeys} from '../../../shared/storage';

export type CodeUsageFlag = 'used' | 'unUsed' | null;

export const isConfirmationCodeUsed = async (): Promise<CodeUsageFlag> => {
  const res = await storage.getItem<CodeUsageFlag>(StorageKeys.changeContactsCodeIdUsage);
  return res;
};
